const initialState = {
  members: [],
  invites: { pending: [], expired: [] },
  remainingInvites: 0,
}

export default function membership(state = initialState, event) {
  switch (event.type) {
    case "UPDATE_ORG_MEMBERS":
      return {
        ...state,
        members: event.members,
      }

    case "UPDATE_ORG_INVITES":
      return {
        ...state,
        invites: event.invites,
      }

    case "UPDATE_ORG_INVITE_COUNT":
      return {
        ...state,
        remainingInvites: event.remainingInvites,
      }

    default:
      return state
  }
}
